import { useState, useRef, useCallback } from "react";

/**
 * Arrastre del panel del modal (misma lógica que ModalWhatsApp / ModalNota).
 * Asigna dragRef al contenedor del modal y onMouseDown={startDrag} en la barra de título.
 */
export function useDraggableModalPanel() {
  const [pos, setPos] = useState(null);
  const dragRef = useRef(null);
  const dragOffsetRef = useRef(null);

  const startDrag = useCallback((e) => {
    if (
      e.target.closest("button") ||
      e.target.closest("input") ||
      e.target.closest("textarea") ||
      e.target.closest("select") ||
      e.target.closest("a")
    ) {
      return;
    }
    const rect = dragRef.current?.getBoundingClientRect();
    if (!rect) return;
    dragOffsetRef.current = { ox: e.clientX - rect.left, oy: e.clientY - rect.top, w: rect.width, h: rect.height };
    document.body.style.userSelect = "none";
    const onMove = (ev) => {
      if (!dragOffsetRef.current) return;
      const { ox, oy, w, h } = dragOffsetRef.current;
      setPos({
        x: Math.max(0, Math.min(window.innerWidth - w, ev.clientX - ox)),
        y: Math.max(0, Math.min(window.innerHeight - h, ev.clientY - oy)),
      });
    };
    const onUp = () => {
      dragOffsetRef.current = null;
      document.body.style.userSelect = "";
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    };
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  }, []);

  const panelPositionStyle = pos ? { position: "fixed", left: pos.x, top: pos.y, margin: 0 } : { position: "relative" };

  return { dragRef, startDrag, panelPositionStyle };
}
